import { render } from "./price-formatter.vue?vue&type=template&id=9870df8a"
import script from "./price-formatter.vue?vue&type=script&lang=js"
export * from "./price-formatter.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ian/codebase/toteme-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__